import React from 'react';
import NewOpenShiftCard from './NewOpenShiftCard';
import OpenShiftCard from './OpenShiftCard';

// Layout constants shared with ScheduleDisplay2's row-height math.
export const OPEN_SHIFT_ROW_HEIGHT = 30;
export const OPEN_SHIFT_ROW_GAP = 4;
export const OPEN_SHIFT_VISIBLE_CAP = 3;

const OpenShiftsDropdown = ({
  daily_open_shifts,
  laborLawViolations,
  showActualTimes,
  edit_mode,
  subheader_box_size_style2,
  // Props for NewOpenShiftCard
  all_data,
  week_in_past,
  date_str,
  addShift,
  store_id,
  get_t_str,
  date_name,
  saveShiftFinished,
  setSaveShiftFinished,
  d,
  copiedShift,
  setCopiedShift,
  addMultipleShifts,
  minimizeMode,
  businessWeekStartDayIndex,
  start_qhnum,
  schedule_day_end_qhnum,
  defaultBreakLengthHours,
  breakRequiredWhenShiftLengthExceeds,
  secondBreakShiftLengthThreshold,
  businessDeclineShiftOptionEnabled,
  paidBreakInputsEnabled,
  restBreakRegulation,
  store_team_member_weekly_info,
  // Props for OpenShiftCard
  lockAllShifts,
  p,
  windowWidth
}) => {
  const [showAll, setShowAll] = React.useState(false);
  const visibleShifts =
    showAll || daily_open_shifts.length <= OPEN_SHIFT_VISIBLE_CAP
      ? daily_open_shifts
      : daily_open_shifts.slice(0, OPEN_SHIFT_VISIBLE_CAP);
  const hiddenCount = daily_open_shifts.length - visibleShifts.length;

  // Always-open row: the day's open shift cards, then the add cell on
  // editable days. Past days with nothing open render an empty cell.
  return (
    <div className="border-t border-gray-200" style={subheader_box_size_style2}>
      <div className="w-full flex flex-col" style={{ gap: OPEN_SHIFT_ROW_GAP }}>
        {visibleShifts.map((v, i) => (
          <div key={v.id ?? i} className="w-full" style={{ height: OPEN_SHIFT_ROW_HEIGHT }}>
            <OpenShiftCard
              laborLawViolations={laborLawViolations}
              showActualTimes={showActualTimes}
              edit_mode={edit_mode}
              weekly_or_daily="weekly"
              shift_info={v}
              lockAllShifts={lockAllShifts}
              p={p}
              locked_mode={lockAllShifts}
              addShift={addShift}
              get_t_str={get_t_str}
              date_name={date_name}
              role_names={all_data.role_names}
              saveShiftFinished={saveShiftFinished}
              setSaveShiftFinished={setSaveShiftFinished}
              d={d}
              setCopiedShift={setCopiedShift}
              copiedShift={copiedShift}
              minimizeMode={minimizeMode}
              role_types={all_data.role_types}
              businessWeekStartDayIndex={businessWeekStartDayIndex}
              start_qhnum={start_qhnum}
              schedule_day_end_qhnum={schedule_day_end_qhnum}
              defaultBreakLengthHours={defaultBreakLengthHours}
              breakRequiredWhenShiftLengthExceeds={breakRequiredWhenShiftLengthExceeds}
              secondBreakShiftLengthThreshold={secondBreakShiftLengthThreshold}
              businessDeclineShiftOptionEnabled={businessDeclineShiftOptionEnabled}
              paidBreakInputsEnabled={paidBreakInputsEnabled}
              restBreakRegulation={restBreakRegulation}
              store_team_member_weekly_info={store_team_member_weekly_info}
              windowWidth={windowWidth}
            />
          </div>
        ))}

        {hiddenCount > 0 && (
          <button
            type="button"
            onClick={() => setShowAll(true)}
            className="self-start px-1 text-xxs font-semibold text-violet-700 hover:text-violet-900"
            style={{ height: OPEN_SHIFT_ROW_HEIGHT }}
          >
            +{hiddenCount} more
          </button>
        )}

        {edit_mode && (
          <div style={{ height: OPEN_SHIFT_ROW_HEIGHT }}>
            <div className="w-full h-full relative">
              <NewOpenShiftCard
                role_names={all_data.role_names}
                week_in_past={week_in_past}
                weekly_or_daily="weekly"
                date_str={date_str}
                addShift={addShift}
                store_id={store_id}
                get_t_str={get_t_str}
                date_name={date_name}
                saveShiftFinished={saveShiftFinished}
                setSaveShiftFinished={setSaveShiftFinished}
                d={d}
                copiedShift={copiedShift}
                setCopiedShift={setCopiedShift}
                addMultipleShifts={addMultipleShifts}
                minimizeMode={minimizeMode}
                role_types={all_data.role_types}
                businessWeekStartDayIndex={businessWeekStartDayIndex}
                start_qhnum={start_qhnum}
                schedule_day_end_qhnum={schedule_day_end_qhnum}
                defaultBreakLengthHours={defaultBreakLengthHours}
                breakRequiredWhenShiftLengthExceeds={breakRequiredWhenShiftLengthExceeds}
                secondBreakShiftLengthThreshold={secondBreakShiftLengthThreshold}
                businessDeclineShiftOptionEnabled={businessDeclineShiftOptionEnabled}
                paidBreakInputsEnabled={paidBreakInputsEnabled}
                restBreakRegulation={restBreakRegulation}
              />
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default OpenShiftsDropdown;
